import axios from "@/api/config";

const subjectCourse = {
  getPageList(data) {
    return axios.post(`${process.env.BASE_URL}/subjectCourse/pageList`, data);
  },
  addSubjectCourse(data) {
    return axios.post(
      `${process.env.BASE_URL}/subjectCourse/addSubjectCourse`,
      data
    );
  },
  updateSubjectCourse(data) {
    return axios.put(
      `${process.env.BASE_URL}/subjectCourse/updateSubjectCourse`,
      data
    );
  },
  //延期
  delayGoods(data) {
    /* let base = ''
    if (process.env.NODE_ENV.includes('production')) { base = "https://api.g.68wx.com" } else {
      base = "http://test.api.68wx.com"
    }
    return axios.put(
      `${base}/orderInfo/delayGoods`,
      data
    ); */
    return axios.put(
      `${process.env.BASE_URL}/orderInfo/delayGoods`,
      data
    );
  },
  offSubjectCourse(data) {
    return axios.get(`${process.env.BASE_URL}/subjectCourse/offSubjectCourse`, {
      params: data
    });
  },
  onSubjectCourse(data) {
    return axios.get(`${process.env.BASE_URL}/subjectCourse/onSubjectCourse`, {
      params: data
    });
  },
  getSubjectCourseListByPid(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourse/getSubjectCourseListByPid`,
      { params: data }
    );
  },
  getSubjectCourse(data) {
    return axios.get(`${process.env.BASE_URL}/subjectCourse/getSubjectCourse`, {
      params: data
    });
  },
  getPListByLevel(data) {
    return axios.get(`${process.env.BASE_URL}/subjectCourse/getPListByLevel`, {
      params: data
    });
  },
  getSubjectCourseAllTree(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourse/getSubjectCourseAllTree`,
      { params: data }
    );
  },
  addSubjectCourseOrganization(data) {
    return axios.post(
      `${process.env.BASE_URL}/subjectCourse/addSubjectCourseOrganization`,
      data
    );
  },
  getClassInfoTree(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourse/getClassInfoTree/` + data,
      {}
    );
  },
  getPlanTree(data) {
    return axios.get(`${process.env.BASE_URL}/subjectCourse/getPlanTree`, {
      params: data
    });
  },
  getPlanList(data) {
    return axios.get(`${process.env.BASE_URL}/subjectCourse/getPlanList`, {
      params: data
    });
  },
  getSubjectTreeList(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourse/getSubjectTreeList`,
      { params: data }
    );
  },
  getSubjectTreeListByAgentId(data) {
    return axios.get(
      `${process.env.BASE_URL}/subjectCourse/getSubjectTreeListByAgentId`,
      { params: data }
    );
  },
  forbidden(data) {
    return axios.post(
      `${process.env.BASE_URL}/subjectCourseOrganization/forbidden`,
      data
    );
  },
  startUsing(data) {
    return axios.post(
      `${process.env.BASE_URL}/subjectCourseOrganization/startUsing`,
      data
    );
  },
  getSubjectConfig(data) {
    return axios.get(`${process.env.BASE_URL}/subjectConfig/getSubjectConfig`, {
      params: data
    });
  },
  addSubjectConfig(data) {
    return axios.post(
      `${process.env.BASE_URL}/subjectConfig/addSubjectConfig`,
      data
    );
  },
  updateSubjectConfig(data) {
    return axios.put(
      `${process.env.BASE_URL}/subjectConfig/updateSubjectConfig`,
      data
    );
  },

  updateSubjectCourseOrganization(data) {
    return axios.put(
      `${process.env.BASE_URL}/subjectCourseOrganization/updateSubjectCourseOrganization `,
      data
    );
  }
};

export default subjectCourse;



// WEBPACK FOOTER //
// ./src/api/subjectCourse.js